import { z } from 'zod';

const { DOCUMENTAION_LINKS } = require('dictionary');

export const DOC_LINKS = {
  exchanges: DOCUMENTAION_LINKS.CONFIGURE.EXCHANGE_CATALOG,
  purchases: DOCUMENTAION_LINKS.CONFIGURE.PURCHASE_CATALOG
};

const OPTION_SCHEMA = z.array(
  z.object({ value: z.string(), label: z.string() })
);

export const FORM_SCHEMA = z.object({
  productTypes: OPTION_SCHEMA,
  productCategories: OPTION_SCHEMA,
  collections: OPTION_SCHEMA,
  excludedTags: OPTION_SCHEMA,
  minPrice: z.string().refine(val => !isNaN(Number(val)), {
    message: 'Minimum price must be a valid number'
  }),
  showDigitalProducts: z.boolean(),
  showSaleItems: z.boolean().default(true)
});

/** @typedef {z.infer<typeof FORM_SCHEMA>} FormSchemaType */

/** @type {FormSchemaType} */
export const DEFAULT_FORM_DATA = {
  productTypes: [],
  productCategories: [],
  collections: [],
  excludedTags: [],
  minPrice: 0,
  showDigitalProducts: false,
  showSaleItems: true
};
